<template>
   <div id="resetPasswordUserModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header deactiveModal-bgcolor">
          <button type="button" class="close" data-toggle="modal" data-target="#resetPasswordUserModal">&times;</button>
        </div>
        <div class="modal-body desc-text">
          <div class="modal-title" v-if="showTab == 1">
            <div class="title-text">Do you want to reset your password for the user?</div>
              <div class="bold-text" v-if="user">{{user.email_id}}</div>
          </div>
          <div class="modal-title" v-if="showTab == 2">
            <div class="title-text">New Password</div>
            <div class="bold-text">{{generatedPassword}}
              <input type="hidden" ref="password" v-model="generatedPassword"/>
              <base-tooltip content="Copy to clipboard">
                <i class="fa fa-clone" aria-hidden="true" v-clipboard:copy="generatedPassword"></i>
              </base-tooltip>
            </div>
             <p class="mr-tp-10">you can copy the password and share it to the user.</p>
          </div>
        </div>
        <div class="modal-footer deactiveModal-bgcolor">
          <template v-if="showTab == 1">
          <div class="col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-white-button"
              href="#ConfirmationModal"
              @click="resetPassword"
            >Yes, Proceed</button>
          </div>
          <div class="col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-blue-button"
              data-toggle="modal"
              data-target="#resetPasswordUserModal"
            >Cancel</button>
          </div>
          </template>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { resetUserPassword } from '../../apis/activityTracker';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  props: ['user'],
  data() {
    return {
      loaderStatus: false,
      showTab: 1,
      generatedPassword: '',
    };
  },
  components: {
    Loader,
    BaseTooltip,
  },
  computed: {
  },
  methods: {
    async resetPassword() {
      this.loaderStatus = true;
      const respData = await resetUserPassword(this.user.user_id, this.user.account_id);
      if (respData && respData.data) {
        this.showTab = 2;
        this.generatedPassword = respData.data;
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to reset password!',
          group: 'custom-notification',
        });
      }
      this.loaderStatus = false;
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
  mounted() {
    $('#resetPasswordUserModal').on('hidden.bs.modal', () => {
      this.showTab = 1;
    });
  },
};
</script>

<style scoped>
.mr-tp-10{
  margin-top: 10px;
}
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.modal-header.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-content.first-modal-content {
  border-radius: 12px;
}
.title-text {
  font-size: 18px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
}
.bold-text {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.desc-text {
  padding: 5px 55px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #828282;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}
.modal-header.scnd-deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0px;
}
div#deactiveModal {
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-title i.fa-clone{
  padding:0;
  padding-left:5px;
  cursor:pointer;
}
@media screen and (max-width:320px) {
  .desc-text{
    padding:5px 20px;
  }
}
</style>
